import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';
import type { SelectOption } from '@/shared/types';

import type { TagItem } from '@/entities/tags';

import { updateGlossaryCategoryTags } from '@/features/glossary/api';

export type UpdateGlossaryCategoryTagsParams = {
  glossaryCategoryId: string;
  newTagFQNs: string[];
  availableTags: SelectOption<string>[];
  currentTags: TagItem[];
};

export const useUpdateGlossaryCategoryTags = (categoryName: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      glossaryCategoryId,
      newTagFQNs,
      availableTags,
      currentTags,
    }: UpdateGlossaryCategoryTagsParams) => {
      await updateGlossaryCategoryTags(glossaryCategoryId, newTagFQNs, availableTags, currentTags);
    },
    onError: (error) => {
      console.error('태그 업데이트 실패: ', error);
      notification.error({
        message: NOTIFICATION_MESSAGES.TAG_UPDATE_ERROR,
        description: NOTIFICATION_MESSAGES.TAG_UPDATE_ERROR_DESC,
        duration: 2,
        placement: 'bottomLeft',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: glossaryKeys.categoryInfo(categoryName) });
      notification.success({
        message: NOTIFICATION_MESSAGES.TAG_UPDATE_SUCCESS,
        description: NOTIFICATION_MESSAGES.TAG_UPDATE_SUCCESS_DESC,
        duration: 2,
        placement: 'bottomLeft',
      });
    },
  });
};
